import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import { ExternalUserFindInterface } from '@zaoblako/shared/modules/security/dtos/external-user/external-user-find.dto';
import type { UserFindInterface } from '@zaoblako/shared/modules/security/dtos/user/user-find.dto';
import { MultiSelectComponent } from '@zaoblako/web/shared/dumbs/dropdowns/multi-select/multi-select.component';

@Component({
  standalone: true,
  selector: 'crm-user-with-external-multi-select',
  templateUrl: './user-with-external-multi-select.component.html',
  imports: [CommonModule, MultiSelectComponent],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UserWithExternalMultiSelectComponent implements OnChanges {
  @ViewChild('multiSelectComponent') public multiSelectComponent: MultiSelectComponent;

  @Input() public users: UserFindInterface[] = [];
  @Input() public externalUsers: ExternalUserFindInterface[] = [];

  public _users: (UserFindInterface | ExternalUserFindInterface)[] = [];

  @Input() public selectedUsers: (UserFindInterface | ExternalUserFindInterface)[] = [];
  @Output() public selectedUsersChange: EventEmitter<(UserFindInterface | ExternalUserFindInterface)[]> =
    new EventEmitter<(UserFindInterface | ExternalUserFindInterface)[]>();

  @Input() public class = '';
  @Input() public styleClass: string;
  @Input() public appendTo: string;
  @Input() public scrollHeight: string = '300px';
  @Input() public disabled = false;
  @Input() public itemSubDescriptionField = 'job';
  @Input() public showClear = true;
  @Input() public isError = false;
  @Input() public isFloatLabel = true;
  @Input() public placeholder = '\u00A0';
  @Input() public display = 'chip';
  @Input() public moveDown = false;
  @Input() public sort = 'profile.name:string';
  @Input() public label = 'Пользователь';
  @Input() public onlyInternal = false;

  public constructor(private readonly cdRef: ChangeDetectorRef) {}

  public ngOnChanges(changes: SimpleChanges) {
    if (changes.users) {
      this._users = this._users.concat(this.users?.map((user) => ({ ...user, job: 'Внутренний пользователь' })));
      this.cdRef.markForCheck();
    }
    if (changes.externalUsers) {
      this._users = this._users.concat(
        this.externalUsers?.map((externalUser) => ({ ...externalUser, job: 'Внешний пользователь' }))
      );
      this.cdRef.markForCheck();
    }
    if (changes.onlyInternal) {
      if (this.onlyInternal) {
        this._users = this.users?.map((user) => ({ ...user, job: 'Внутренний пользователь' }));
        this.selectedUsers = this.selectedUsers?.filter(
          (selectedUser) => this.users?.findIndex((user) => selectedUser?.id === user?.id) !== -1
        );
        this.selectedUsersChange.emit(this.selectedUsers);
      } else {
        this._users = this._users.concat(
          this.externalUsers?.map((externalUser) => ({ ...externalUser, job: 'Внешний пользователь' }))
        );
      }
    }
  }
}
